import { configureStore } from "@reduxjs/toolkit"

import { rootReducer } from "./reducer"

import { IS_DEVELOPMENT } from "utils/env-management"

const store = configureStore({
    reducer: rootReducer,
    devTools: IS_DEVELOPMENT,
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export { store }
